import React, { useState, useEffect } from "react";
import {
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Box,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import { useUser } from "../../context/UserContext";
import axios from "axios";
import jsPDF from "jspdf";
import "../../StylesCSS/EtudiantsInterieurVille.css";
import "jspdf-autotable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { API_BASE_URL } from "../dashboardContent/config";

const ListeEtudiantsExclus = ({ setActiveSection }) => {
  const { userId } = useUser();
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedAnneeScolaire, setSelectedAnneeScolaire] = useState("");
  const [
    selectedReceptionInstitution,
    setSelectedReceptionInstitution,
  ] = useState("");
  console.log("selectedReceptionInstitution", selectedReceptionInstitution);

  const [selectedDate, setSelectedDate] = useState("");
  const [valueDate, setValueDate] = useState("");
  const [valuePlace, setValuePlace] = useState("");

  const [directorate, setDirectorate] = useState("");
  const [town, setTown] = useState("");
  const [institutions1, setInstitutions1] = useState([]);
  const [selectedInstitution1, setSelectedInstitution1] = useState("");
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  const [commonCore, setCommonCore] = useState("");
  const [boarding, setBoarding] = useState("");
  const [futureSchool, setFutureSchool] = useState("");
  const [external, setExternal] = useState("");

  const [etablissements, setEtablissements] = useState([]);
  const [selectedEtablissement, setSelectedEtablissement] = useState("");
  console.log("commoncore -->>>", commonCore);
  console.log("id user -->>>", userId);

  // Charger les établissements chaque fois que "commonCore" change
  useEffect(() => {
    if (commonCore && userId) {
      axios
        .get(`${API_BASE_URL}/version3/api/etablissements/by-common-core-and-user`, {
          params: { commonCore, userId },
        })
        .then((response) => {
          setEtablissements(response.data);
          setSelectedEtablissement(""); // Réinitialiser la sélection
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des établissements:", error);
          setEtablissements([]);
        });
    }
  }, [commonCore, userId]);

  console.log("institution ->", selectedInstitution);
  console.log("selectedCode", selectedCode);
  console.log("selectedDate", selectedDate);

  console.log("institutions1", institutions1);
  console.log("classes", classes);
  console.log("selectedInstitution1", selectedInstitution1);
  console.log("selectedClass", selectedClass);
  console.log("Directorate:", directorate);
  console.log("Town:", town);
  console.log("Common Core:", commonCore);
  console.log("Boarding:", boarding);
  console.log("Future School:", futureSchool);
  console.log("External:", external);

  // Récupérer les institutions
  useEffect(() => {
    axios
      .get(
        `${API_BASE_URL}/version3/api/originalinstitution/institutionsOriginal/${userId}`
      )
      .then((response) => {
        console.log("Institutions récupérées:", response.data); // Debugging
        setInstitutions1(response.data);
      })
      .catch((error) =>
        console.error("Erreur lors de la récupération des institutions:", error)
      );
  }, [userId]);

  const [selectedInstitution2, setSelectedInstitution2] = useState("");
  const [receptionInstitutions, setReceptionInstitutions] = useState([]);

  useEffect(() => {
    console.log("Institution sélectionnée :", selectedInstitution1);
    if (selectedInstitution1) {
      console.log("selectedInstitution1", selectedInstitution1);
      axios
        .get(
          `${API_BASE_URL}/version3/api/receptioninstitution/by-original/${selectedInstitution1}/user/${userId}`
        )
        .then((response) => {
          console.log("Réceptions récupérées:", response.data); // Vérifie ce que l'API retourne
          setReceptionInstitutions(response.data);
        })
        .catch((error) =>
          console.error(
            "Erreur lors de la récupération des institutions d’accueil:",
            error
          )
        );
    } else {
      setReceptionInstitutions([]); // Réinitialiser si aucune institution originale n'est sélectionnée
    }
  }, [selectedInstitution1, userId]);

  // Récupérer les classes quand une institution est sélectionnée
  useEffect(() => {
    if (selectedInstitution1) {
      axios
        .get(
          `${API_BASE_URL}/version3/api/excel/classes/${userId}/${selectedInstitution1}`
        )
        .then((response) => setClasses(response.data))
        .catch((error) =>
          console.error("Erreur lors de la récupération des classes:", error)
        );
    }
  }, [selectedInstitution1, userId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/version3/api/excel/institutions/${userId}`)
      .then((response) => setInstitutions(response.data))
      .catch((error) =>
        console.error("Erreur lors de la récupération des institutions:", error)
      );
  }, [userId]);

  const handleSave = async () => {
    const dataToSave = {
      user: { id: userId }, // Assurez-vous d'envoyer l'objet utilisateur avec son id
      institution: selectedInstitution,
      code: selectedCode, // Ajout de رمزها
      date: selectedAnneeScolaire, // Ajout de تاريخ انعقاد المجلس
    };

    // Sauvegarde des données
    try {
      const saveResponse = await axios.post(
        `${API_BASE_URL}/version3/api/deuxieme-langue/save`,
        dataToSave
      );
      console.log("Données sauvegardées:", saveResponse.data);
      // Vous pouvez ajouter ici une notification de succès ou rediriger l'utilisateur
    } catch (error) {
      console.error("Erreur lors de la sauvegarde des données:", error);
    }
  };

    const [directions, setDirections] = useState({ direction_provinciale: '', direction_regionale: '' });
  const [loading, setLoading] = useState(true);


   useEffect(() => {
    if (userId) {
      axios.get(`${API_BASE_URL}/api/forms/directions/${userId}`)
        .then(response => {
          console.log('Direction provinciale :', response.data.direction_provinciale);
          console.log('Direction régionale :', response.data.direction_regionale);
          setDirections(response.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Erreur lors du chargement des directions:', error);
          setLoading(false);
        });
    }
  }, [userId]);

  const getNombresRepartitionEtudiants = async (selectedInstitution) => {
    const response = await fetch(
      `${API_BASE_URL}/version3/api/students/Repartition_des_etudiants?selectedInstitution=${selectedInstitution}`
    );
    const data = await response.json();
    return data; // retourne un objet { filles: x, garcons: y }
  };

  // Exemple d'utilisation dans ton composant
  getNombresRepartitionEtudiants(selectedInstitution).then((data) => {
    console.log("countFillesByEnglish1:", data.countFillesByEnglish1);
    console.log("countFillesBySpain1:", data.countFillesBySpain1);
    console.log("somme", data.sommeFilles1);
    console.log("data", data);
    // Insérer ces valeurs dans le tableau du PDF
  });

  const getFilteredStudents = async (
    selectedInstitution1,
  ) => {
    try {
      console.log("Selected Institution:", selectedInstitution1);
      console.log("User ID:", userId); // Afficher l'userId dans la console pour débogage

      const response = await axios.get(
        `${API_BASE_URL}/version3/api/students/getStudentsExclus`,
        {
          params: {
            selectedInstitution1: selectedInstitution1,
            userId: userId,
          },
        }
      );

      console.log("Données des étudiants filtrés:", response.data); // Afficher les données dans la console
      return response.data; // Retourner les données des étudiants filtrés
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des étudiants filtrés:",
        error
      );
      return [];
    }
  };

  const handleGoBack = (section) => {
    setActiveSection(section);
    console.log("Retour");
  };

  const handleExportPDF = async () => {
    const students = await getFilteredStudents(
      selectedInstitution1,
    );
    console.log("student",students);
    const studentTableData = students.map((student, index) => ({
      classe: student.classe,
      nature: student.nature,
      deux_an_avant: student.deux_an_avant,
      un_an_avant: student.un_an_avant,
      niveauActuel: student.niveauActuel,
      numeroEleve: student.numeroEleve,
      nomEtPrenom: student.nomEtPrenom,
      num: index + 1,
    }));
    console.log("table students", studentTableData);

    const doc = new jsPDF("p", "pt", "a4");

    // Ajouter la police arabe
    doc.addFont(
      "/fonts/NotoSansArabic-Regular.ttf",
      "NotoSansArabic",
      "normal"
    );
    doc.setFont("NotoSansArabic");
    doc.setFontSize(12);

    const img = new Image();
    img.src = "/images/Photo1.PNG";
    await new Promise((resolve) => {
      img.onload = resolve;
    });

    const imgWidth = 250;
    const imgHeight = (img.height * imgWidth) / img.width;
    doc.addImage(
      img,
      "PNG",
      (doc.internal.pageSize.width - imgWidth) / 2,
      10,
      imgWidth,
      imgHeight
    );

    doc.setFont("NotoSansArabic");

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0); // Couleur noire pour les trois premières lignes

    // Ajouter les trois premiers textes avec les nouvelles propriétés
    doc.text(
  `الأكاديمية الجهوية : ${directions.direction_regionale}`, 
  doc.internal.pageSize.width / 2, 
  imgHeight + 15, 
  { align: 'center' }
);

doc.text(
  `مديرية ${directions.direction_provinciale}`, 
  doc.internal.pageSize.width / 2, 
  imgHeight + 20, 
  { align: 'center' }
);
    doc.text(
      "  مصلحة تأطير المؤسسات التعليمية و التوجيه  ",
      doc.internal.pageSize.width / 2,
      imgHeight + 45,
      { align: "center" }
    );

    const pageWidth = doc.internal.pageSize.width;
    const centerX = pageWidth / 2;

    doc.setFontSize(9);
    doc.text(
      "  المؤسسة : " + selectedInstitution1,
      doc.internal.pageSize.width - 20,
      imgHeight + 60,
      { align: "right" }
    );

    doc.setFontSize(9);
    doc.text(
      "  المستوى و الشعبة : " + selectedCode,
      doc.internal.pageSize.width - 220,
      imgHeight + 60,
      { align: "right" }
    );
    // Définir les marges
    const leftMargin = 320; // marge gauche en mm
    const rightMargin = 20; // marge droite en mm
    const availableWidth = pageWidth - leftMargin - rightMargin; // Largeur disponible

    // Appliquer NotoSans uniquement sur selectedCode
   /*  doc.setFont("NotoSansArabic");
    const codeX = leftMargin; // Positionner à la marge gauche
    const codeY = imgHeight + 60; // Position verticale
    doc.text(selectedCode + " : ", codeX, codeY, { align: "left" }); // Afficher selectedCode

    // Appliquer NotoSansArabic uniquement sur 'رمزها'
    doc.setFont("NotoSansArabic");
    const prefix = "المستوى و الشعبة";

    const prefixX = leftMargin + 20 + doc.getTextWidth(" : ", selectedCode); // Positionner après le selectedCode
    const prefixY = codeY; // Même position verticale que selectedCode
    doc.text(prefix, prefixX, prefixY, { align: "left" });
 */
    doc.setFont("NotoSansArabic");
    doc.text(
      "  السنة الدراسية: " + selectedAnneeScolaire,
      80,
      imgHeight + 60,
      { align: "left" }
    );

    doc.text(
      "لائحة التلاميذ المفصولين",
      doc.internal.pageSize.width / 2,
      imgHeight + 75,
      { align: "center" }
    );
    // Obtenir la largeur du texte pour calculer la position de la ligne
    const textWidth = doc.getTextWidth("لائحة التلاميذ المفصولين");
    const textXPosition = doc.internal.pageSize.width / 2 - textWidth / 2;
    doc.setLineWidth(2);

    // Dessiner une ligne sous le texte
    doc.line(
      textXPosition,
      imgHeight + 80,
      textXPosition + textWidth,
      imgHeight + 80
    );


    // Définir les colonnes du tableau
    const columns = [
      { header: "اعادة الادماج", dataKey: "reintegration" },
      { header: "الرقم بمحضر التوجيه", dataKey: "guidanceReportNumber" },
      { header: "القسم", dataKey: "class" },
      { header: "الجنس", dataKey: "gender" },
      { header: "الاولى", dataKey: "firstChoice" },
      { header: "الثانية", dataKey: "secondChoice" },
      { header: "الثالثة", dataKey: "thirdChoice" },
      { header: "رقم مسار", dataKey: "massarId" },
      { header: "الاسم الكامل", dataKey: "fullName" },
      { header: "الرقم الترتيبي", dataKey: "serialNumber" },
    ];

    doc.autoTable({
      startY: 180, // Commence à 280px en haut pour la première page
      head: [columns.map((col) => col.header)],
      body: studentTableData.map((row) => ({
        reintegration: '',
        guidanceReportNumber: '',
        class: row.classe,
        gender: row.nature,
        firstChoice: row.deux_an_avant,
        secondChoice: row.un_an_avant,
        thirdChoice: row.niveauActuel,
        massarId: row.numeroEleve,
        fullName: row.nomEtPrenom,
        serialNumber: row.num,
      })),      
      columns: columns,
      styles: {
        font: "NotoSansArabic",
        halign: "right",
        fontSize: 7,
      },
      headStyles: {
        fillColor: [230, 230, 230], // gris clair (tu peux changer)
        textColor: 0, // noir
        halign: 'center',
        fontStyle: 'bold',
        fontSize: 7.2,
      },
      columnStyles: {
        0: { cellWidth: 'auto' },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 'auto' },
        4: { cellWidth: 'auto' },
        5: { cellWidth: 'auto' },
        6: { cellWidth: 'auto' },
        7: { cellWidth: 'auto' },
        8: { cellWidth: 'auto' },
        9: { cellWidth: 'auto' },
      },      
      margin: { top: 180, right: 10, left: 10 }, // Marge pour la premتاière page
      didDrawPage: function(data) {
        if (data.pageNumber === 1) {
          // Marge pour la première page
          data.settings.margin.top = 21;
        } else {
          // Marge pour les pages suivantes
          data.settings.margin.top = 10;
        }

        // Ajuster la marge après la 23ème ligne
        const lastRowIndex = data.cursor.index; // Obtenir l'index de la dernière ligne dessinée
        if (lastRowIndex === 22) {
          // 22 car les index commencent à 0
          data.settings.margin.top = 50; // Changer la marge selon le besoin
        }
      },
      didParseCell: function(data) {
        // Appliquer une police spécifique à la colonne "رقم مسار"
        if (data.section === "body" && data.column.dataKey === "massarId") {
          data.cell.styles.font = "NotoSans";
          data.cell.styles.fontStyle = 'bold'; // optionnel

        }
      },      
    });
    const totalPages = doc.internal.getNumberOfPages();
    console.log("total number", totalPages);

    for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
      doc.setPage(pageNumber);

      // Position de la ligne de bas de page
      const pageHeight = doc.internal.pageSize.height;
      const footerYPosition = pageHeight - 50; // Ajuste la position verticale ici (30 mm du bas)

      // Vérifiez si nous sommes sur la dernière page
      if (pageNumber === totalPages) {
        // Dessiner le texte de bas de page uniquement sur la dernière page
        doc.setFont("NotoSansArabic");
        doc.text(
          " حـــرر بــ : " + valueDate + "  " + "في  : " + valuePlace,
          pageWidth / 2,
          footerYPosition,
          { align: "center" }
        );
        doc.text(": توقيع رئيس المؤسسة ", 480, footerYPosition + 20);
      }
    }
    // Enregistrer le PDF
    doc.save("لائحة التلاميذ المفصولين.pdf");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        padding: "2rem",
        backgroundColor: "#f4f6f8", // Couleur de fond douce
        borderRadius: "10px",
        border: "1px solid #dcdcdc",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        maxWidth: "700px",
        margin: "auto",
        textAlign: "right",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          marginBottom: "1rem",
          fontWeight: "500",
          color: "#2c3e50",
          textAlign: "center",
        }}
      >
        لائحة التلاميذ المفصولين
      </Typography>

      <TextField
        fullWidth
        label="المستوى و الشعبة"
        value={selectedCode}
        onChange={(e) => setSelectedCode(e.target.value)}
        sx={{ marginBottom: "1rem", textAlign: "right", direction: "rtl" }}
      />
      <TextField
        fullWidth
        label="السنة الدراسية"
        value={selectedAnneeScolaire}
        onChange={(e) => setSelectedAnneeScolaire(e.target.value)}
        sx={{ marginBottom: "1rem", textAlign: "right", direction: "rtl" }}
      />

      <label htmlFor="original-school">: المؤسسة الاصلية</label>
      <select
        className="select"
        onChange={(e) => setSelectedInstitution1(e.target.value)} // Mettre à jour selectedInstitution1
        value={selectedInstitution1} // Utiliser selectedInstitution1 comme valeur
      >
        <option value="" style={{ textAlign: "right" }}>
          -- اختر --
        </option>
        {institutions1 &&
          institutions1.length > 0 &&
          institutions1.map((institution) => (
            <option
              key={institution.id}
              value={institution.name} // Utiliser institution.name ici pour la valeur
            >
              {institution.name}
            </option>
          ))}
      </select>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      ></div>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "1rem",
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => handleGoBack("PageLayout3V3")}
          sx={{
            borderRadius: "8px",
            borderColor: "#e74c3c", // Couleur de la bordure rouge
            color: "#e74c3c", // Couleur du texte
            "&:hover": {
              backgroundColor: "#f8d7da", // Couleur au survol
            },
          }}
        >
          رجوع
        </Button>

        <button
          onClick={handleExportPDF}
          className="btn btn-secondary"
          style={{
            width: "120px", // Largeur fixe
            height: "50px", // Hauteur fixe
            padding: "10px 20px", // Marges internes pour ajuster la taille
            fontSize: "13px", // Taille du texte
            borderRadius: "8px", // Coins arrondis
          }}
        >
          PDF تصدير إلى
        </button>
      </Box>
    </Box>
  );
};

export default ListeEtudiantsExclus;
